import React, { useState, useEffect } from 'react';
import OrderButton from '../components/OrderButton';
import '../styles/pages/Menu.css';

const Menu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMenuItems();
  }, []);

  const fetchMenuItems = async () => {
    try {
      const response = await fetch('https://hamza-texas-bzuqgf4l9-kamrans-projects-8a64a81c.vercel.app/api/menu');
      if (!response.ok) throw new Error('Failed to fetch menu items');
      const data = await response.json();
      setMenuItems(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const categories = ['all', 'wings', 'burgers', 'sides', 'drinks'];

  const filteredItems = selectedCategory === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === selectedCategory);

  if (loading) return <div className="loading">Loading menu items...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="menu-page">
      <div className="menu-hero">
        <div className="menu-hero-content">
          <h1>Our Menu</h1>
          <p>Fresh, never frozen wings and more</p>
        </div>
      </div>

      <div className="menu-container">
        <div className="menu-categories">
          {categories.map(category => (
            <button
              key={category}
              className={`category-button ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        <div className="menu-grid">
          {filteredItems.map(item => (
            <div key={item.id} className="menu-item-card">
              <div className="menu-item-image">
                <img src={item.image} alt={item.name} />
              </div>
              <div className="menu-item-content">
                <h3>{item.name}</h3>
                <p className="description">{item.description}</p>
                <p className="price">${item.price.toFixed(2)}</p>
                <OrderButton item={item} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sauce-section">
        <h2>Our Signature Sauces</h2>
        <div className="sauce-grid">
          <div className="sauce-card">
            <h3>Classic Buffalo</h3>
            <p>Our traditional wing sauce with the perfect blend of heat and flavor</p>
          </div>
          <div className="sauce-card">
            <h3>Garlic Parmesan</h3>
            <p>Creamy garlic sauce with aged parmesan cheese</p>
          </div>
          <div className="sauce-card">
            <h3>Honey BBQ</h3>
            <p>Sweet and tangy barbecue sauce with a touch of honey</p>
          </div>
          <div className="sauce-card">
            <h3>Spicy Thai Chili</h3>
            <p>Sweet and spicy sauce with Asian-inspired flavors</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
